module.exports = __webpack_public_path__ + "static/media/GW.6a8fd12d.svg";